import type { SecureLinkPurpose } from '@roc-capital/secure-link';

/** Purpose of the referral fee secure link (the backend's SecureLinkPurpose.REFERRAL_FEE_BANK_INFO). */
export const REFERRAL_FEE_BANK_INFO_PURPOSE: SecureLinkPurpose = 'REFERRAL_FEE_BANK_INFO';
